import template from './template.pug';

function getCombinedPath(path1, path2) {
  if (!path1) {
    return '';
  }

  return path1 + (path2 ? `/${path2}` : '');
}

function getDisplayUrl(domain, path) {
  if (!domain) {
    return '';
  }

  if (!path) {
    return domain;
  }

  return `${domain}/${path}`;
}

function getDynamicSearchAdDisplayUrl(domain, path1, path2) {
  return getDisplayUrl(domain, getCombinedPath(path1, path2));
}

const dynamicSearchAdPreviewTemplate = function ({ itemViewModel, i18n }) {
  const newVM = {
    convertedTitle: `{${i18n.getString('Ad_DSA_Title')}}`,
    convertedDisplayUrl: getDynamicSearchAdDisplayUrl(
      itemViewModel.DisplayUrl,
      itemViewModel.Path1,
      itemViewModel.Path2
    ),
    Text: itemViewModel.Text,
  };

  return template({ itemViewModel: newVM, i18n });
};

export { dynamicSearchAdPreviewTemplate, getDynamicSearchAdDisplayUrl };
